const S = "liquid-ajax-cart",
  A = "data-ajax-cart",
  Ue = "ajax-cart",
  X = "js-ajax-cart",
  De = `${S}:init`;
var ke = function (e, t, n, i) {
  return new (n || (n = Promise))(function (a, o) {
    function r(d) {
      try {
        l(i.next(d));
      } catch (u) {
        o(u);
      }
    }
    function s(d) {
      try {
        l(i.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      var u;
      d.done
        ? a(d.value)
        : ((u = d.value),
          u instanceof n
            ? u
            : new n(function (v) {
                v(u);
              })).then(r, s);
    }
    l((i = i.apply(e, [])).next());
  });
};
const O = "add",
  Q = "change",
  Y = "update",
  Ee = "clear",
  _ = "get",
  Ke = `${S}:queue-start`,
  M = `${S}:queue-start-internal`,
  Ie = `${S}:queue-empty-internal`,
  B = `${S}:queue-end-internal`,
  Xe = `${S}:queue-end`,
  G = `${S}:request-start-internal`,
  Qe = `${S}:request-start`,
  j = `${S}:request-end-internal`,
  Ye = `${S}:request-end`,
  E = [];
let K = !1;
function N(e) {
  var t;
  !((t = e.options) === null || t === void 0) && t.important && E.length !== 0
    ? E[0].push(e)
    : E.push([e]) === 1 && (Je(!0), ge());
}
function ge() {
  if (E.length === 1 && E[0].length === 0) {
    const i = new CustomEvent(Ie);
    document.dispatchEvent(i);
  }
  if (E.length === 0) return void Je(!1);
  if (E[0].length === 0) return (E.shift(), void ge());
  const { requestType: e, body: t, options: n } = E[0][0];
  (function (i, a, o, r) {
    var s;
    const { extraRequestOnError: l } = g,
      d = We(i);
    let u;
    i !== _ && (u = a || {});
    const v = i === _ ? "GET" : "POST",
      y = o.info || {},
      h = { requestType: i, endpoint: d, requestBody: u, info: y },
      m = [],
      b = [],
      F = new CustomEvent(G, {
        detail: { requestState: { requestType: i, endpoint: d, info: y, requestBody: u } },
      });
    document.dispatchEvent(F);
    const R = new CustomEvent(Qe, {
      detail: { requestState: { requestType: i, endpoint: d, info: y, requestBody: u } },
    });
    if ((document.dispatchEvent(R), y.cancel)) return ((h.responseData = null), void ne(o, r, h));
    if (!((s = o?.signal) === null || s === void 0) && s.aborted)
      return ((h.responseData = null), (h.fetchError = "AbortError"), void ne(o, r, h));
    if (u !== void 0) {
      let c;
      if (
        (u instanceof FormData || u instanceof URLSearchParams
          ? u.has("sections") && (c = u.get("sections").toString())
          : (c = u.sections),
        typeof c == "string" || c instanceof String || Array.isArray(c))
      ) {
        if (
          (Array.isArray(c) ? m.push(...c) : m.push(...c.split(",")),
          O === i && b.push(...m.slice(0, 5)),
          m.length > 5)
        ) {
          b.push(...m.slice(5));
          const f = m.slice(0, 5).join(",");
          u instanceof FormData || u instanceof URLSearchParams
            ? u.set("sections", f)
            : (u.sections = f);
        }
      } else
        c != null &&
          console.error(
            `Liquid Ajax Cart: "sections" parameter in a Cart Ajax API request must be a string or an array. Now it is ${c}`
          );
    }
    const p = { method: v };
    (o?.signal && (p.signal = o.signal),
      i !== _ &&
        (u instanceof FormData || u instanceof URLSearchParams
          ? ((p.body = u), (p.headers = { "x-requested-with": "XMLHttpRequest" }))
          : ((p.body = JSON.stringify(u)), (p.headers = { "Content-Type": "application/json" }))),
      fetch(d, p)
        .then((c) =>
          ke(this, void 0, void 0, function* () {
            const f = yield c.json();
            return { ok: c.ok, status: c.status, body: f };
          })
        )
        .then((c) =>
          ke(this, void 0, void 0, function* () {
            var f;
            return (
              (h.responseData = c),
              !h.responseData.ok && l && b.unshift(...m.slice(0, 5)),
              b.length > 0 &&
                ((!((f = o?.signal) === null || f === void 0) && f.aborted) ||
                  (h.extraResponseData = yield Ve(b, o?.signal))),
              h
            );
          })
        )
        .catch((c) => {
          ((!c || (c.name !== "AbortError" && c.code !== 20)) &&
            (console.error("Liquid Ajax Cart: Error while performing cart Ajax request"),
            console.error(c)),
            (h.responseData = null),
            (h.fetchError = c));
        })
        .finally(() => {
          ne(o, r, h);
        }));
  })(e, t, n, () => {
    (E[0].shift(), ge());
  });
}
function Je(e) {
  K = e;
  const t = new CustomEvent(K ? M : B);
  document.dispatchEvent(t);
  const n = new CustomEvent(K ? Ke : Xe);
  document.dispatchEvent(n);
}
function ne(e, t, n) {
  if ("firstCallback" in e)
    try {
      e.firstCallback(n);
    } catch (r) {
      (console.error('Liquid Ajax Cart: Error in request "firstCallback" function'),
        console.error(r));
    }
  const i = { requestState: n },
    a = new CustomEvent(j, { detail: i });
  document.dispatchEvent(a);
  const o = new CustomEvent(Ye, { detail: i });
  if ((document.dispatchEvent(o), "lastCallback" in e))
    try {
      e.lastCallback(n);
    } catch (r) {
      (console.error('Liquid Ajax Cart: Error in request "lastCallback" function'),
        console.error(r));
    }
  t();
}
function Ve(e = [], t) {
  const n = { updates: {} };
  return (
    e.length > 0 && (n.sections = e.slice(0, 5).join(",")),
    fetch(We(Y), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(n),
      signal: t,
    }).then((i) =>
      i.json().then((a) => {
        const o = { ok: i.ok, status: i.status, body: a };
        return e.length < 6
          ? o
          : Ve(e.slice(5), t).then((r) => {
              var s;
              return (
                r.ok &&
                  !((s = r.body) === null || s === void 0) &&
                  s.sections &&
                  typeof r.body.sections == "object" &&
                  ("sections" in o.body || (o.body.sections = {}),
                  (o.body.sections = Object.assign(
                    Object.assign({}, o.body.sections),
                    r.body.sections
                  ))),
                o
              );
            });
      })
    )
  );
}
function et(e = {}) {
  N({ requestType: _, body: void 0, options: e });
}
function Le(e = {}, t = {}) {
  N({ requestType: O, body: e, options: t });
}
function ee(e = {}, t = {}) {
  N({ requestType: Q, body: e, options: t });
}
function H(e = {}, t = {}) {
  N({ requestType: Y, body: e, options: t });
}
function Ze(e = {}, t = {}) {
  N({ requestType: Ee, body: e, options: t });
}
function We(e) {
  var t, n, i, a, o, r, s, l, d, u;
  switch (e) {
    case O:
      return `${((n = (t = window.Shopify) === null || t === void 0 ? void 0 : t.routes) === null || n === void 0 ? void 0 : n.root) || "/"}cart/add.js`;
    case Q:
      return `${((a = (i = window.Shopify) === null || i === void 0 ? void 0 : i.routes) === null || a === void 0 ? void 0 : a.root) || "/"}cart/change.js`;
    case _:
      return `${((r = (o = window.Shopify) === null || o === void 0 ? void 0 : o.routes) === null || r === void 0 ? void 0 : r.root) || "/"}cart.js`;
    case Ee:
      return `${((l = (s = window.Shopify) === null || s === void 0 ? void 0 : s.routes) === null || l === void 0 ? void 0 : l.root) || "/"}cart/clear.js`;
    case Y:
      return `${((u = (d = window.Shopify) === null || d === void 0 ? void 0 : d.routes) === null || u === void 0 ? void 0 : u.root) || "/"}cart/update.js`;
    default:
      return;
  }
}
function L() {
  return K;
}
const _e = `${A}-initial-state`;
let qe,
  x = null;
function w() {
  return { cart: x, previousCart: qe };
}
const oe = `${A}-bind`;
function ie() {
  w().cart &&
    document.querySelectorAll(`[${oe}]`).forEach((e) => {
      const t = e.getAttribute(oe);
      e.textContent = (function (n) {
        const { binderFormatters: i } = g,
          [a, ...o] = n.split("|");
        let r = ze(a, w().cart);
        return (
          o.forEach((s) => {
            const l = s.trim();
            l !== "" &&
              (typeof i == "object" && l in i
                ? (r = i[l](r))
                : l in Oe
                  ? (r = Oe[l](r))
                  : console.warn(`Liquid Ajax Cart: the "${l}" formatter is not found`));
          }),
          typeof r == "string" || r instanceof String || typeof r == "number" || r instanceof Number
            ? r.toString()
            : (console.error(
                `Liquid Ajax Cart: the calculated value for the ${oe}="${n}" element must be string or number. But the value is`,
                r
              ),
              "")
        );
      })(t);
    });
}
function ze(e, t) {
  const n = e.split("."),
    i = n.shift().trim();
  return i !== "" && i in t && n.length > 0 ? ze(n.join("."), t[i]) : t[i];
}
const Oe = {
  money_with_currency: (e) => {
    var t;
    const n = w();
    if (typeof e != "number" && !(e instanceof Number))
      return (
        console.error(
          "Liquid Ajax Cart: the 'money_with_currency' formatter is not applied because the value is not a number. The value is ",
          e
        ),
        e
      );
    const i = e / 100;
    return "Intl" in window && !((t = window.Shopify) === null || t === void 0) && t.locale
      ? Intl.NumberFormat(window.Shopify.locale, {
          style: "currency",
          currency: n.cart.currency,
        }).format(i)
      : `${i.toFixed(2)} ${n.cart.currency}`;
  },
};
let k,
  $e = !1;
function re() {
  const { mutations: e } = g;
  (Array.isArray(e) ||
    console.error('Liquid Ajax Cart: the "mutations" settings parameter must be an array'),
    e.length !== 0 && (($e = !1), (k = -1), Se()));
}
function Se() {
  const { mutations: e } = g;
  if ((k++, k >= e.length)) return;
  let t = [];
  try {
    const n = e[k]();
    n && (t = n?.requests || []);
  } catch (n) {
    (console.error(`Liquid Ajax Cart: Error in the "mutation" function with index ${k}`),
      console.error(n));
  }
  Array.isArray(t) ? we(t) : Se();
}
function we(e) {
  const t = e.shift();
  if (t) {
    if (t.type && [O, Q, Y, Ee, _].includes(t.type))
      return void N({
        requestType: t.type,
        body: t.body,
        options: {
          info: { initiator: "mutation" },
          important: !0,
          lastCallback: (n) => {
            we(e);
          },
        },
      });
    console.error(`Liquid Ajax Cart: wrong request type in the mutation with index ${k}`);
  }
  e.length > 0 ? we(e) : Se();
}
const g = {
    binderFormatters: {},
    requestErrorText: "There was an error while updating your cart. Please try again.",
    updateOnWindowFocus: !0,
    quantityTagAllowZero: !1,
    quantityTagDebounce: 300,
    mutations: [],
    extraRequestOnError: !0,
  },
  T = `${A}-section`,
  ae = `${A}-static-element`,
  se = `${A}-section-scroll`,
  ue = "shopify-section-",
  Ae = `${Ue}-product-form`,
  ce = "processing";
class Ge extends HTMLElement {
  connectedCallback() {
    var t, n;
    const i = this,
      a = this.querySelectorAll("form");
    if (a.length !== 1)
      return void console.error(
        `Liquid Ajax Cart: "${Ae}" element must have one "form" element as a child, ${a.length} found`,
        i
      );
    const o = a[0];
    new URL(o.action).pathname ===
    `${((n = (t = window.Shopify) === null || t === void 0 ? void 0 : t.routes) === null || n === void 0 ? void 0 : n.root) || "/"}cart/add`
      ? o.addEventListener("submit", (r) => {
          if (!i.hasAttribute(ce)) {
            const s = new FormData(o);
            (i.setAttribute(ce, ""),
              Le(s, {
                lastCallback: () => {
                  i.removeAttribute(ce);
                },
                info: { initiator: i },
              }));
          }
          r.preventDefault();
        })
      : console.error(
          `Liquid Ajax Cart: "${Ae}" element's form "action" attribute value isn't a product form action URL`,
          o,
          i
        );
  }
}
var le, de, fe, he, pe, me, ve, ye;
const P = `${((de = (le = window.Shopify) === null || le === void 0 ? void 0 : le.routes) === null || de === void 0 ? void 0 : de.root) || "/"}cart/change`,
  U = `${((he = (fe = window.Shopify) === null || fe === void 0 ? void 0 : fe.routes) === null || he === void 0 ? void 0 : he.root) || "/"}cart/add`,
  I = `${((me = (pe = window.Shopify) === null || pe === void 0 ? void 0 : pe.routes) === null || me === void 0 ? void 0 : me.root) || "/"}cart/clear`,
  J = `${((ye = (ve = window.Shopify) === null || ve === void 0 ? void 0 : ve.routes) === null || ye === void 0 ? void 0 : ye.root) || "/"}cart/update`,
  D = `${A}-request-button`;
function tt(e, t) {
  let n;
  const i = [P, U, I, J];
  if (!e.hasAttribute(D)) return;
  const a = e.getAttribute(D);
  if (a) {
    let r;
    try {
      if (((r = new URL(a, window.location.origin)), !i.includes(r.pathname)))
        throw `URL should be one of the following: ${P}, ${U}, ${J}, ${I}`;
      n = r;
    } catch (s) {
      console.error(`Liquid Ajax Cart: ${D} contains an invalid URL as a parameter.`, s);
    }
  } else if (e instanceof HTMLAnchorElement && e.hasAttribute("href")) {
    const r = new URL(e.href);
    i.includes(r.pathname)
      ? (n = r)
      : e.hasAttribute(D) &&
        console.error(
          `Liquid Ajax Cart: a link with the ${D} contains an invalid href URL.`,
          `URL should be one of the following: ${P}, ${U}, ${J}, ${I}`
        );
  }
  if (n === void 0)
    return void console.error(`Liquid Ajax Cart: a ${D} element doesn't have a valid URL`);
  if ((t && t.preventDefault(), L())) return;
  const o = new FormData();
  switch (
    (n.searchParams.forEach((r, s) => {
      o.append(s, r);
    }),
    n.pathname)
  ) {
    case U:
      Le(o, { info: { initiator: e } });
      break;
    case P:
      ee(o, { info: { initiator: e } });
      break;
    case J:
      H(o, { info: { initiator: e } });
      break;
    case I:
      Ze({}, { info: { initiator: e } });
  }
}
function te(e, t) {
  let n, i;
  return (
    e.length > 3
      ? ((n = t.cart.items.find((a) => a.key === e)), (i = "id"))
      : ((n = t.cart.items[Number(e) - 1]), (i = "line")),
    n === void 0 &&
      ((n = null), console.error(`Liquid Ajax Cart: line item with ${i}="${e}" not found`)),
    [n, i]
  );
}
const q = `${A}-quantity-input`;
function je(e) {
  return !(
    !e.hasAttribute(q) ||
    (!(
      (e instanceof HTMLInputElement && ["text", "number"].includes(e.type)) ||
      (e instanceof HTMLSelectElement && ["select-one"].includes(e.type))
    ) &&
      (console.error(
        `Liquid Ajax Cart: the ${q} attribute supports "input" elements of types "text", "number" and non-multiple "select" elements`
      ),
      1))
  );
}
function V() {
  document.querySelectorAll(`input[${q}], select[${q}]`).forEach((e) => {
    if (!je(e)) return;
    if (L()) return void (e.disabled = !0);
    const t = w(),
      n = e.getAttribute(q).trim(),
      [i] = te(n, t);
    (i ? (e.value = i.quantity.toString()) : i === null && (e.value = "0"), (e.disabled = !1));
  });
}
function Ne(e, t) {
  if (!je(e) || (t && t.preventDefault(), L())) return;
  let n = Number(e.value.trim());
  const i = e.getAttribute(q).trim();
  if (isNaN(n))
    return void console.error(`Liquid Ajax Cart: input value of a ${q} must be an Integer number`);
  if ((n < 1 && (n = 0), !i))
    return void console.error(
      `Liquid Ajax Cart: attribute value of a ${q} must be an item key or an item index`
    );
  const a = i.length > 3 ? "id" : "line",
    o = new FormData();
  (o.set(a, i), o.set("quantity", n.toString()), ee(o, { info: { initiator: e } }), e.blur());
}
const $ = `${A}-property-input`;
function Re(e) {
  const t = e.getAttribute($),
    n = e.getAttribute("name");
  console.error(
    `Liquid Ajax Cart: the element [${$}="${t}"]${n ? `[name="${n}"]` : ""} has wrong attributes.`
  );
}
function xe(e) {
  return (
    !!e.hasAttribute($) &&
    ((e instanceof HTMLInputElement && e.type !== "hidden") ||
      e instanceof HTMLTextAreaElement ||
      e instanceof HTMLSelectElement)
  );
}
function Ce(e) {
  const t = { objectCode: void 0, propertyName: void 0, attributeValue: void 0 };
  if (!e.hasAttribute($)) return t;
  let n = e.getAttribute($).trim();
  if (!n) {
    const o = e.getAttribute("name").trim();
    o && (n = o);
  }
  if (!n) return (Re(e), t);
  if (((t.attributeValue = n), n === "note")) return ((t.objectCode = "note"), t);
  let [i, ...a] = n.trim().split("[");
  return !a || a.length !== 1 || a[0].length < 2 || a[0].indexOf("]") !== a[0].length - 1
    ? (Re(e), t)
    : ((t.objectCode = i), (t.propertyName = a[0].replace("]", "")), t);
}
function Z() {
  document.querySelectorAll(`[${$}]`).forEach((e) => {
    if (!xe(e)) return;
    if (L()) return void (e.disabled = !0);
    const { objectCode: t, propertyName: n, attributeValue: i } = Ce(e);
    if (!t) return;
    const a = w();
    let o,
      r = !1;
    if (t === "note") o = a.cart.note;
    else if (t === "attributes") o = a.cart.attributes[n];
    else {
      const [s, l] = te(t, a);
      (s && (o = s.properties[n]),
        s === null &&
          (console.error(
            `Liquid Ajax Cart: line item with ${l}="${t}" was not found when the [${$}] element with "${i}" value tried to get updated from the State`
          ),
          (r = !0)));
    }
    (e instanceof HTMLInputElement && (e.type === "checkbox" || e.type === "radio")
      ? (e.checked = e.value === o)
      : (typeof o == "string" ||
          o instanceof String ||
          typeof o == "number" ||
          o instanceof Number ||
          (Array.isArray(o) || o instanceof Object
            ? ((o = JSON.stringify(o)),
              console.warn(
                `Liquid Ajax Cart: the ${$} with the "${i}" value is bound to the ${n} ${t === "attributes" ? "attribute" : "property"} that is not string or number: ${o}`
              ))
            : (o = "")),
        (e.value = o)),
      r || (e.disabled = !1));
  });
}
function Me(e, t) {
  if (!xe(e)) return;
  (t && t.preventDefault(), e.blur());
  const n = w();
  if (L()) return;
  const { objectCode: i, propertyName: a, attributeValue: o } = Ce(e);
  if (!i) return;
  let r = e.value;
  if (e instanceof HTMLInputElement && e.type === "checkbox" && !e.checked) {
    let s = document.querySelector(`input[type="hidden"][${$}="${o}"]`);
    (s ||
      (i !== "note" && i !== "attributes") ||
      (s = document.querySelector(`input[type="hidden"][${$}][name="${o}"]`)),
      (r = s ? s.value : ""));
  }
  if (i === "note") {
    const s = new FormData();
    (s.set("note", r), H(s, { info: { initiator: e } }));
  } else if (i === "attributes") {
    const s = new FormData();
    (s.set(`attributes[${a}]`, r), H(s, { info: { initiator: e } }));
  } else {
    const [s, l] = te(i, n);
    if (
      (s === null &&
        console.error(
          `Liquid Ajax Cart: line item with ${l}="${i}" was not found when the [${$}] element with "${o}" value tried to update the cart`
        ),
      !s)
    )
      return;
    const d = Object.assign({}, s.properties);
    d[a] = r;
    const u = new FormData();
    let v = u;
    (u.set(l, i), u.set("quantity", s.quantity.toString()));
    for (let y in d) {
      const h = d[y];
      typeof h == "string" || h instanceof String
        ? u.set(`properties[${y}]`, d[y])
        : (v = { [l]: i, quantity: s.quantity, properties: d });
    }
    ee(v, { info: { initiator: e } });
  }
}
const W = `${Ue}-quantity`,
  Be = `${A}-quantity-plus`,
  He = `${A}-quantity-minus`;
function nt() {
  (customElements.define(Ae, Ge),
    document.addEventListener(
      "click",
      function (e) {
        for (let t = e.target; t && t != document.documentElement; t = t.parentElement) tt(t, e);
      },
      !1
    ),
    document.addEventListener(
      "change",
      function (e) {
        Me(e.target, e);
      },
      !1
    ),
    document.addEventListener(
      "keydown",
      function (e) {
        const t = e.target;
        (e.key === "Enter" && ((t instanceof HTMLTextAreaElement && !e.ctrlKey) || Me(t, e)),
          e.key === "Escape" &&
            (function (n) {
              if (
                !xe(n) ||
                !(n instanceof HTMLInputElement || n instanceof HTMLTextAreaElement) ||
                (n instanceof HTMLInputElement && (n.type === "checkbox" || n.type === "radio"))
              )
                return;
              const i = w(),
                { objectCode: a, propertyName: o } = Ce(n);
              if (!a) return;
              let r;
              if (a === "note") r = i.cart.note;
              else if (a === "attributes") r = i.cart.attributes[o];
              else {
                const [s] = te(a, i);
                s && (r = s.properties[o]);
              }
              (r !== void 0 &&
                (r || typeof r == "string" || r instanceof String || (r = ""),
                (n.value = String(r))),
                n.blur());
            })(t));
      },
      !1
    ),
    document.addEventListener(M, Z),
    document.addEventListener(j, Z),
    document.addEventListener(B, Z),
    Z(),
    document.addEventListener(
      "change",
      function (e) {
        Ne(e.target, e);
      },
      !1
    ),
    document.addEventListener(
      "keydown",
      function (e) {
        (e.key === "Enter" && Ne(e.target, e),
          e.key === "Escape" &&
            (function (t) {
              if (!je(t)) return;
              const n = t.getAttribute(q).trim();
              let i;
              const a = w();
              if (n.length > 3) i = a.cart.items.find((o) => o.key === n);
              else {
                const o = Number(n) - 1;
                i = a.cart.items[o];
              }
              (i && (t.value = i.quantity.toString()), t.blur());
            })(e.target));
      },
      !1
    ),
    document.addEventListener(M, V),
    document.addEventListener(j, V),
    document.addEventListener(B, V),
    V(),
    customElements.define(
      W,
      class extends HTMLElement {
        constructor() {
          (super(...arguments), (this._timer = void 0));
        }
        connectedCallback() {
          const e = this.querySelectorAll("input");
          e.length === 1
            ? ((this._$input = e[0]),
              this._$input.hasAttribute(q)
                ? ((this._$buttons = Array.from(this.querySelectorAll(`[${He}], [${Be}]`))),
                  this._$input.addEventListener("change", this._updateDOM.bind(this)),
                  document.addEventListener(M, this._updateDOM.bind(this)),
                  document.addEventListener(j, this._updateDOM.bind(this)),
                  document.addEventListener(B, this._updateDOM.bind(this)),
                  this._updateDOM(),
                  this._$buttons.forEach((t) => {
                    (t.addEventListener("click", (n) => {
                      const { quantityTagAllowZero: i } = g,
                        a = i === !0 ? 0 : 1;
                      if (!L()) {
                        const o = Number(this._$input.value);
                        if (isNaN(o))
                          return void console.error(
                            `Liquid Ajax Cart: "${W}" element's input value isn't a number`,
                            this._$input,
                            this
                          );
                        let r = o,
                          s = Number(this._$input.getAttribute("step") || 1);
                        ((!Number.isSafeInteger(s) || s <= 0) && (s = 1),
                          (r = t.hasAttribute(Be) ? r + s : r - s),
                          r < a && (r = a),
                          r !== o &&
                            ((this._$input.value = r.toString()),
                            this._runAwaiting(),
                            this._updateDOM()));
                      }
                      n.preventDefault();
                    }),
                      t.addEventListener("focusout", (n) => {
                        (n.relatedTarget && t.contains(n.relatedTarget)) ||
                          (this._timer !== void 0 && this._runRequest());
                      }));
                  }))
                : console.error(
                    `Liquid Ajax Cart: "${W}" element's input must have the "${q}" attribute`,
                    this._$input,
                    this
                  ))
            : console.error(
                `Liquid Ajax Cart: "${W}" element must have one "input" element as a child, ${e.length} found`,
                this
              );
        }
        _runAwaiting() {
          const { quantityTagDebounce: e } = g;
          (this._timer !== void 0 && clearTimeout(this._timer),
            e > 0
              ? (this._timer = setTimeout(() => {
                  this._runRequest();
                }, Number(e)))
              : this._runRequest());
        }
        _runRequest() {
          (this._timer !== void 0 && clearTimeout(this._timer),
            (this._timer = void 0),
            L() || this._$input.dispatchEvent(new Event("change", { bubbles: !0 })));
        }
        _updateDOM() {
          this._$buttons.forEach((e) => {
            const t =
              L() || (e.hasAttribute(He) && !g.quantityTagAllowZero && this._$input.value === "1");
            (t ? e.setAttribute("aria-disabled", "true") : e.removeAttribute("aria-disabled"),
              e instanceof HTMLButtonElement && e.toggleAttribute("disabled", t));
          });
        }
      }
    ));
}
const be = `${A}-errors`,
  Fe = (e) => {
    switch (e.requestType) {
      case O:
        return ((t) => {
          var n;
          const i = (n = t.info) === null || n === void 0 ? void 0 : n.initiator;
          return i instanceof Ge ? Array.from(i.querySelectorAll(`[${be}="form"]`)) : [];
        })(e);
      case Q:
        return ((t) => {
          var n;
          const i = [],
            a = w();
          let o, r;
          if (
            (t.requestBody instanceof FormData || t.requestBody instanceof URLSearchParams
              ? (t.requestBody.has("line") && (r = t.requestBody.get("line").toString()),
                t.requestBody.has("id") && (o = t.requestBody.get("id").toString()))
              : ("line" in t.requestBody && (r = String(t.requestBody.line)),
                "id" in t.requestBody && (o = String(t.requestBody.id))),
            r)
          ) {
            const s = Number(r);
            if (s > 0) {
              const l = s - 1;
              o = (n = a.cart.items[l]) === null || n === void 0 ? void 0 : n.key;
            }
          }
          return (
            o &&
              (o.indexOf(":") > -1
                ? i.push(...Array.from(document.querySelectorAll(`[${be}="${o}"]`)))
                : i.push(
                    ...Array.from(
                      document.querySelectorAll(
                        a.cart.items
                          .reduce(
                            (s, l) => (
                              (l.key !== o && l.id !== Number(o)) || s.push(`[${be}="${l.key}"]`),
                              s
                            ),
                            []
                          )
                          .join(",")
                      )
                    )
                  )),
            i
          );
        })(e);
      default:
        return [];
    }
  },
  ot = `${X}-init`,
  it = `${X}-processing`,
  rt = `${X}-empty`,
  at = `${X}-not-empty`;
function z() {
  const e = document.querySelector("html"),
    t = w();
  (e.classList.toggle(ot, t.cart !== null),
    e.classList.toggle(it, L()),
    e.classList.toggle(rt, t.cart.item_count === 0),
    e.classList.toggle(at, t.cart.item_count > 0));
}
let Pe = !1;
if (!("liquidAjaxCart" in window)) {
  let e = function (t, n) {
    Object.defineProperty(window.liquidAjaxCart, t, {
      get: n,
      set: () => {
        throw new Error(`Liquid Ajax Cart: the "${t}" is a read-only property`);
      },
      enumerable: !0,
    });
  };
  var st = e;
  ((window.liquidAjaxCart = {
    conf: function (t, n) {
      t in g
        ? ((g[t] = n),
          window.liquidAjaxCart.init &&
            (t === "binderFormatters" && ie(), t === "mutations" && re()))
        : console.error(`Liquid Ajax Cart: unknown configuration parameter "${t}"`);
    },
  }),
    e("init", () => Pe),
    document.addEventListener(G, (t) => {
      const { requestState: n } = t.detail;
      if (n.requestBody !== void 0) {
        const i = [];
        if (
          (document.querySelectorAll(`[${T}]`).forEach((a) => {
            const o = a.closest(`[id^="${ue}"]`);
            if (o) {
              const r = o.id.replace(ue, "");
              i.indexOf(r) === -1 && i.push(r);
            } else
              console.error(
                `Liquid Ajax Cart: there is a ${T} element that is not inside a Shopify section. All the ${T} elements must be inside Shopify sections.`
              );
          }),
          i.length)
        ) {
          let a,
            o = i.join(",");
          (n.requestBody instanceof FormData || n.requestBody instanceof URLSearchParams
            ? n.requestBody.has("sections") && (a = n.requestBody.get("sections").toString())
            : (a = n.requestBody.sections),
            (((typeof a == "string" || a instanceof String) && a !== "") ||
              (a && Array.isArray(a) && a.length > 0)) &&
              (o = `${a.toString()},${o}`),
            n.requestBody instanceof FormData || n.requestBody instanceof URLSearchParams
              ? n.requestBody.set("sections", o)
              : (n.requestBody.sections = o));
        }
      }
    }),
    document.addEventListener(j, (t) => {
      var n, i, a, o;
      t.detail.sections = [];
      const { requestState: r } = t.detail,
        s = new DOMParser(),
        l = [];
      if (
        r.responseData.body.sections ||
        (!(
          (i = (n = r.extraResponseData) === null || n === void 0 ? void 0 : n.body) === null ||
          i === void 0
        ) &&
          i.sections)
      ) {
        let d = r.responseData.body.sections;
        !(
          (o = (a = r.extraResponseData) === null || a === void 0 ? void 0 : a.body) === null ||
          o === void 0
        ) &&
          o.sections &&
          (d = Object.assign(Object.assign({}, d), r.extraResponseData.body.sections));
        for (let u in d)
          d[u]
            ? document.querySelectorAll(`#shopify-section-${u}`).forEach((v) => {
                let y = [];
                const h = "__noId__",
                  m = {};
                v.querySelectorAll(` [${se}] `).forEach((p) => {
                  let c = p.getAttribute(se).toString().trim();
                  (c === "" && (c = h),
                    c in m || (m[c] = []),
                    m[c].push({ scroll: p.scrollTop, height: p.scrollHeight }));
                });
                const b = {},
                  F = v.querySelectorAll(`[${ae}]`);
                F &&
                  F.forEach((p) => {
                    let c = p.getAttribute(ae).toString().trim();
                    (c === "" && (c = h), c in b || (b[c] = []), b[c].push(p));
                  });
                const R = v.querySelectorAll(`[${T}]`);
                if (R) {
                  const p = s.parseFromString(d[u], "text/html");
                  p.querySelectorAll('img[loading="lazy"]').forEach((f) => {
                    f.removeAttribute("loading");
                  });
                  for (let f in b)
                    p.querySelectorAll(` [${ae}="${f.replace(h, "")}"] `).forEach((C, Te) => {
                      Te + 1 <= b[f].length && (C.before(b[f][Te]), C.parentElement.removeChild(C));
                    });
                  const c = p.querySelectorAll(`[${T}]`);
                  if (R.length !== c.length) {
                    console.error(
                      `Liquid Ajax Cart: the received HTML for the "${u}" section has a different quantity of the "${T}" containers. The section will be updated completely.`
                    );
                    const f = p.querySelector(`#${ue}${u}`);
                    if (f) {
                      for (v.innerHTML = ""; f.childNodes.length; ) v.appendChild(f.firstChild);
                      y.push(v);
                    }
                  } else
                    R.forEach((f, C) => {
                      (f.before(c[C]), f.parentElement.removeChild(f), y.push(c[C]));
                    });
                }
                for (let p in m)
                  v.querySelectorAll(` [${se}="${p.replace(h, "")}"] `).forEach((c, f) => {
                    f + 1 <= m[p].length &&
                      (r.requestType !== O || m[p][f].height >= c.scrollHeight) &&
                      (c.scrollTop = m[p][f].scroll);
                  });
                y.length > 0 && l.push({ id: u, elements: y });
              })
            : console.error(
                `Liquid Ajax Cart: the HTML for the "${u}" section was requested but the response is ${d[u]}`
              );
      }
      l.length > 0 && (t.detail.sections = l);
    }),
    document.addEventListener(G, (t) => {
      const { requestState: n } = t.detail;
      Fe(n).forEach((i) => {
        i.textContent = "";
      });
    }),
    document.addEventListener(j, (t) => {
      const { requestState: n } = t.detail;
      if (n.info.cancel) return;
      const i = Fe(n);
      if (i.length === 0) return;
      const a = (function (o) {
        var r, s, l, d, u, v, y;
        const { requestErrorText: h } = g;
        if (!((r = o.responseData) === null || r === void 0) && r.ok) return "";
        const m =
          ((l = (s = o.responseData) === null || s === void 0 ? void 0 : s.body) === null ||
          l === void 0
            ? void 0
            : l.errors) ||
          ((u = (d = o.responseData) === null || d === void 0 ? void 0 : d.body) === null ||
          u === void 0
            ? void 0
            : u.description) ||
          ((y = (v = o.responseData) === null || v === void 0 ? void 0 : v.body) === null ||
          y === void 0
            ? void 0
            : y.message);
        return m
          ? typeof m == "string"
            ? m
            : typeof m == "object"
              ? Object.values(m)
                  .map((b) => b.join(", "))
                  .join("; ")
              : h
          : h;
      })(n);
      a &&
        i.forEach((o) => {
          o.textContent = a;
        });
    }),
    document.addEventListener(De, re),
    document.addEventListener(Ie, () => {
      $e && re();
    }),
    document.addEventListener(G, (t) => {
      const { requestState: n } = t.detail;
      n.info.initiator !== "mutation" && ($e = !0);
    }),
    (function () {
      document.addEventListener(j, (n) => {
        var i, a;
        const { requestState: o } = n.detail;
        let r;
        (!((i = o.extraResponseData) === null || i === void 0) &&
        i.ok &&
        o.extraResponseData.body.token
          ? (r = o.extraResponseData.body)
          : !((a = o.responseData) === null || a === void 0) &&
            a.ok &&
            o.responseData.body.token &&
            (r = o.responseData.body),
          r && ((qe = x), (x = r), (n.detail.previousCart = qe), (n.detail.cart = x)));
      });
      const t = document.querySelector(`[${_e}]`);
      if (t)
        try {
          x = JSON.parse(t.textContent);
        } catch (n) {
          (console.error(`Liquid Ajax Cart: can't parse cart JSON from the "${_e}" script`),
            console.error(n));
        }
      return new Promise((n, i) => {
        var a, o;
        x
          ? n()
          : fetch(
              `${((o = (a = window.Shopify) === null || a === void 0 ? void 0 : a.routes) === null || o === void 0 ? void 0 : o.root) || "/"}cart.js`,
              { headers: { "Content-Type": "application/json" } }
            )
              .then((r) => r.json())
              .then((r) => {
                ((x = r), n());
              })
              .catch((r) => {
                (console.error(r), i(`Can't load the cart state from the "/cart.js" endpoint`));
              });
      });
    })().then(() => {
      (document.addEventListener(j, ie),
        ie(),
        nt(),
        document.addEventListener(M, z),
        document.addEventListener(j, z),
        document.addEventListener(B, z),
        z(),
        (window.liquidAjaxCart.get = et),
        (window.liquidAjaxCart.add = Le),
        (window.liquidAjaxCart.change = ee),
        (window.liquidAjaxCart.update = H),
        (window.liquidAjaxCart.clear = Ze),
        e("cart", () => w().cart),
        e("processing", L),
        window.addEventListener("focus", () => {
          g.updateOnWindowFocus && H({}, {});
        }),
        window.addEventListener("pageshow", (n) => {
          (n.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") &&
            window.liquidAjaxCart.update({}, {});
        }),
        (Pe = !0));
      const t = new CustomEvent(De);
      document.dispatchEvent(t);
    }));
}
